import React from "react";
import './form.scss';
import Input from "../input/input";
import { Navigate } from "react-router-dom";
// import InfoForm from "../infoForm/infoForm";
// import { useNavigate } from 'react-router-dom'; // <-- import useNavigate hook

let self;
export class Form extends React.Component<any, any> {
    headerOptionData = {headerOption1: '',headerOption2: '', headerOption3: '', }
    headerData:any;
    navigate:any;
    // navigate = useNavigate();

    constructor(props: any) {
        super(props);
        this.state = { noOfHeaderOption: 0, ...this.headerOptionData, isSubmitted:false}
        self = this;
        this.send = this.send.bind(this);
        // this.navigate = useNavigate();
    }
    componentDidMount() {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        // this.navigate = useNavigate();
    //   let previousData:any =  sessionStorage.getItem('portfolioForm');
    //     const { headerList } = JSON.parse(previousData);
    //     console.log('headerList.length',headerList.length)
    //     if(headerList && headerList.length >0) {
    //         this.setState({
    //             noOfHeaderOption: headerList.length,
    //             headerOption1: headerList[0].name,
    //             headerOption2: headerList[1].name,
    //             headerOption3: headerList[2].name,
    //         })
    //     }
    }
    send(event) {
        event.preventDefault();
       
        this.headerData = [{
            name: this.state.headerOption1,
            redirectTo:''
        },
        {
            name: this.state.headerOption2,
            redirectTo:''
        },
        {
            name: this.state.headerOption3,
            redirectTo:''
        },
    ];
    this.setState({isSubmitted:true})
    sessionStorage.setItem('portfolioForm', JSON.stringify({headerList: this.headerData}))
    // self.navigate("/info-list");
    // self.props.history.push('/info-list');
    }
    onInputChange(data:any)  {
            if(data<4) {
                // console.log(data)
                self.setState({ noOfHeaderOption: data });
            }
    }
    headerOptions(data:any, field:any) {
        self.setState({ [field]: data });
    }
    render(): React.ReactNode {

        return (
            <>
           { (!this.state.isSubmitted)&&
           <div className="form__wrapper">
                <h4>Header Options (Max 3 options)</h4>
                <form className="form__item" onSubmit={this.send}>
                <Input placeHolder='How many Header you nead' type='tel' key={0} value={this.state.noOfHeaderOption} maxLength="1"  minLength="1" onInputChange={this.onInputChange}></Input>
                    { (this.state.noOfHeaderOption > 0) ? 
                        Array.from({ length: this.state.noOfHeaderOption }).map((e, i) => {
                           return <Input placeHolder={`Header Option ${i+1}`} type='text' name={`headerOption${i+1}`} key={i} value={this.state[`headerOption${i+1}`]} onInputChange={this.headerOptions}></Input>
                        }) :
                         <p>At max you can add 3 header options</p>
                    }
                    {
                        (this.state.noOfHeaderOption > 0) && <button className="form__button app-btn">Next</button>
                    }
                </form>
            </div>}
            { this.state.isSubmitted&&
                      <Navigate to="/info-list" replace={true} />}
            </>
        )
    }
}

export default Form;